import { Component, Inject, OnChanges, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ACTION_DATA_SERVICE, ActionDataService } from "../../../../services/action/data.service";
import { BaseCustomDialog } from "../base-custom-dialog";
import { ActionIconHelper } from "../../../../helper/action-icon.helper";
import {
  LeadsMultipleStepByStepService
} from "../../../../services/leads-multiple-step-by-step/leads-multiple-step-by-step.service";
import { TranslationDirective } from "../../directives/translation.directive";

@Component({
  selector: 'fi-lead-multiple-step-by-step',
  templateUrl: './lead-multiple-step-by-step.component.html',
  styleUrls: ['./lead-multiple-step-by-step.component.scss'],
  standalone: false,
})
export class LeadMultipleStepByStepComponent extends BaseCustomDialog implements OnInit  {
  contactName = '';
  leadId: number;
  searchedText = '';
  title: string;
  externalEmail: string;
  iconUrl = ActionIconHelper.getActionIconUrl('FILE_COPY', false);
  actionIconUrl = '';
  step: number = 0;
  inValidNote = false;
  isMany: boolean;
  leadsLength: number = 0;
  eachStepValue: number = 0;
  liveStreamOfLeadsProgress: any;
  translationForLiveStream: string;

  constructor(
    public dialogRef: MatDialogRef<LeadMultipleStepByStepComponent>,
    private leadsMultipleStepByStepService: LeadsMultipleStepByStepService,
    @Inject(MAT_DIALOG_DATA) public dialogData: {contactName: string, leadId: number, leadTypeId: number, title: string, leads: number[], actionName: string},
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService
  ) {
    super(dialogRef);

    TranslationDirective.getTranslations().subscribe(translations => {
      this.translationForLiveStream = translations['MESSAGE_BULK_OVERLAY_TEXT'];
    })

    this.contactName = dialogData?.contactName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;
    this.leadsLength = dialogData?.leads?.length;
    this.eachStepValue = 100 / this.leadsLength;
    this.actionIconUrl = ActionIconHelper.getActionIconUrl(dialogData?.actionName, true);



    this.getLiveStreamTranslationData();

    this.leadsMultipleStepByStepService.listenToNextStep().subscribe(data => {
      this.nextStep();
      this.getLiveStreamTranslationData();
      sessionStorage.setItem('this.liveStreamOfLeadsProgress', JSON.stringify(this.liveStreamOfLeadsProgress))

      if(this.leadsLength === this.step){
        this.closeDialog();
      }
    })
  }

  getLiveStreamTranslationData(): void{
    const parts = this.translationForLiveStream.split(' ');
    let stepSet = false;
    if(parts && parts.length){
      this.liveStreamOfLeadsProgress = '';
      for(let item of parts){
        if(item === '{' && !stepSet){
          stepSet = true;
          this.liveStreamOfLeadsProgress += this.step + ' ';
          continue;
        }
        if(item === '}'){
          continue;
        }
        if(item === '{'){
          this.liveStreamOfLeadsProgress += ' ' + this.leadsLength + ' ';
          continue;
        }
        if(item === '}'){
          continue;
        }
        this.liveStreamOfLeadsProgress += ' ' + item;
      }
    }
  }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
    window.location.reload();
  }

  nextStep(): void {
    this.step++;
  }

  cancel(): void {
    this.leadsMultipleStepByStepService.cancelLoading();
    this.closeDialog();
  }

  get progressValue(): number{
    return this.eachStepValue * this.step;

  }
}
